import { render, staticRenderFns } from "./CardBase.vue?vue&type=template&id=94d2c0ac"
import script from "./CardBase.vue?vue&type=script&lang=js"
export * from "./CardBase.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports